<template>
<div>

  <div v-if="$route.fullPath!=='/header'">
    <div class="footer-background">
      <div :class="$vuetify.breakpoint.mdAndUp?'container_80':''">
        <v-row class="mt-5 pt-4 pb-8">
          <v-col class="text-right" cols="12" lg="6" xl="6" md="12" sm="12">
            <div
                :class="$vuetify.breakpoint.mdAndUp?'w-80 text-right':'text-center'"
              >
              <img style="cursor: pointer" alt="icon" width="240"  src="../../assets/pr_logo.png"/>
            </div>
            <div  :class="$vuetify.breakpoint.mdAndUp?'w-80':''">
              <p style="color: #e0e0e0;text-align:justify;font-size: 14px">
                {{info.details ? info.details.footer_about:""}}
              </p>
            </div>
          </v-col>
          <v-col class="align-center text-center" cols="12" lg="6" xl="6" md="12" sm="12">
            <!-- <v-row>
              <v-col cols="6" lg="6" xl="6" md="6" sm="6" class="text-left" dir="ltr">
                <ul
                    :class="$vuetify.breakpoint.mdAndUp?'f-left-border w-80 pr-4':''"
                    class="pt-3">
                  <li>
                    <v-icon  class="list-decor px-2" size="10">mdi-circle</v-icon>
                    <router-link class=" white--text text-decoration-none" to="/">

                      {{$t('home')}}
                    </router-link>
                  </li>
                  <li>
                    <v-icon  class="list-decor px-2" size="10">mdi-circle</v-icon>
                    <router-link class="white--text text-decoration-none" to="/gallery">
                      {{$t('gallery')}}
                    </router-link>
                  </li>
                  <li>
                    <v-icon  class="list-decor px-2" size="10">mdi-circle</v-icon>
                    <router-link class="white--text text-decoration-none" to="/news">
                     {{$t('blogs')}}
                    </router-link>
                  </li>

                </ul>
              </v-col>
              <v-col cols="6" lg="6" xl="6" md="6" sm="6" class="text-left" dir="ltr">
                <ul class="pt-3">
                  <li>
                    <v-icon  class="list-decor px-2" size="10">mdi-circle</v-icon>
                    <router-link class="white--text text-decoration-none" to="/projects">
                      {{$t('projects')}}
                    </router-link>
                  </li>
                  <li>
                    <v-icon  class="list-decor px-2" size="10">mdi-circle</v-icon>
                    <router-link class="white--text text-decoration-none" to="/about-ardakan">
                      {{$t('other_factory')}}
                    </router-link>
                  </li>
                  <li>
                    <v-icon  class="list-decor px-2" size="10">mdi-circle</v-icon>
                    <router-link class="white--text text-decoration-none" to="/all-news">
                      {{$t('links')}}
                      {{$t('news')}}
                    </router-link>
                  </li>

                </ul>
              </v-col>
            </v-row> -->
          </v-col>

        </v-row>



      </div>
    </div>
    <div class="footer-background">
      <div class="container_90">
        <div class=" mb-3 f-bottom-border"></div>
        <v-row class="pa-6 m pt-0">
          <v-col cols="12" xl="3" lg="3" md="3" sm="12">
            <h6 class="mb-2 font-weight-bold">{{$t('central-office')}}</h6>
            <v-row class="align-center justify-center" no-gutters>
              <v-col cols="1">
                <v-icon class="f-icon" size="22" color="#25458c">mdi-map-marker-radius</v-icon>
              </v-col>
              <v-col cols="11">
               <div class="mr-2">
                 <a style="font-size: 12px" target="_blank" :href="contact.address_map" class="text-decoration-none white--text pointer">
                   {{contact.address}}
                 </a>
               </div>
              </v-col>
            </v-row>
            <v-row class="my-4 align-center" no-gutters>
              <v-col cols="1">
                <v-icon class="f-icon" size="22" color="#25458c">mdi-phone</v-icon>
              </v-col>
              <v-col cols="11" class="d-flex justify-start">
                <a style="font-size: 12px" :href="`tel:+98${contact.phone}`" class="mr-2 pointer white--text text-decoration-none" dir="ltr">
                  {{contact.phone}}
                </a>
              </v-col>
            </v-row>

          </v-col>
          <v-col cols="12" xl="3" lg="3" md="3" sm="12">

            <h6 class="mb-2 font-weight-bold">{{$t('factory')}}</h6>


            <v-row class="align-center" no-gutters>
              <v-col cols="1">
                <v-icon class="f-icon" size="22" color="#25458c">mdi-map-marker-radius</v-icon>
              </v-col>
              <v-col cols="11">
                <div class="mr-2">
                  <a style="font-size: 12px" target="_blank" :href="contact.factory_address_map" class="text-decoration-none pointer white--text">
                    {{contact.factory_address}}
                  </a>
                </div>
              </v-col>
            </v-row>
            <v-row class="my-4 align-center" no-gutters>
              <v-col cols="1">
                <v-icon class="f-icon" size="22" color="#25458c">mdi-phone</v-icon>
              </v-col>
              <v-col cols="11" class="d-flex justify-start">
                <a style="font-size: 12px" :href="`tel:+98${contact.factory_phone}`"  class="mr-2 pointer white--text text-decoration-none" dir="ltr">
                  {{contact.factory_phone}}
                </a>
              </v-col>
            </v-row>
          </v-col>
          <v-col  cols="12" xl="3" lg="3" md="3" sm="12">
            <h6 class="mb-2 font-weight-bold">{{$t('email')}}</h6>
            <v-row class="pb-6 d-flex justify-center align-center" no-gutters>
              <v-col cols="1">
                <v-icon class="f-icon" size="22" color="#25458c">mdi-at</v-icon>
              </v-col>
              <v-col cols="11">
                <a style="font-size: 12px" target="_blank" :href="`mailto: ${contact.email}`" class="mr-2 text-decoration-none pointer white--text">
                  {{contact.email}}
                </a>
              </v-col>
            </v-row>
            <div class="d-flex align-center">
<!--              <v-icon class="f-icon" size="22" color="#25458c">mdi-email</v-icon>-->
<!--              <div class="legend sub">-->
<!--                <span class="white&#45;&#45;text" style="font-size: 14px">{{$t('newsletter')}}</span>-->
<!--              </div>-->
            </div>

            <!--            <div >-->
            <!--              <v-row  class="my-4" no-gutters>-->
            <!--                <v-col cols="3">-->
            <!--                  <v-icon class="f-icon" size="22" color="black">mdi-linkedin</v-icon>-->
            <!--                </v-col>-->
            <!--                <v-col cols="3">-->
            <!--                  <v-icon class="f-icon" size="22" color="black">mdi-instagram</v-icon>-->
            <!--                </v-col>-->
            <!--                <v-col cols="3">-->
            <!--                  <v-icon class="f-icon" size="22" color="black">mdi-linkedin</v-icon>-->
            <!--                </v-col>-->
            <!--                <v-col cols="3">-->
            <!--                  <v-icon class="f-icon" size="22" color="black">mdi-instagram</v-icon>-->
            <!--                </v-col>-->
            <!--              </v-row>-->
            <!--            </div>-->
          </v-col>
          <v-col
              :class="$vuetify.breakpoint.mdAndUp?'f-left-border':''"
              class="d-flex align-center my-8" cols="12"  lg="3" xl="3" md="3" sm="12">
            <v-row >
              <v-col v-if="social.instagram" cols="auto" xl="auto" lg="auto" md="6" sm="6">
                <a  :href="social.instagram">
                  <v-img width="32" class="icon-size" src="@/assets/images/footer/instagram_large.png"></v-img>
                </a>
              </v-col>
              <v-col v-if="social.linkedin" cols="auto" xl="auto" lg="auto" md="6" sm="6">
                <a  :href="social.linkedin">
                  <v-img class="icon-size" src="@/assets/images/footer/linkedin_large.png"></v-img>
                </a>
              </v-col>
              <v-col v-if="social.youtube" cols="auto" xl="auto" lg="auto" md="6" sm="6">
                <a  :href="social.youtube">
                  <v-img class="icon-size" src="@/assets/images/footer/youtube_large.png"></v-img>
                </a>
              </v-col>
              <v-col v-if="social.facebook" cols="auto" xl="auto" lg="auto" md="6" sm="6">
                <a  :href="social.facebook">
                  <v-img class="icon-size" src="@/assets/images/footer/facebook_large.png"></v-img>
                </a>
              </v-col>
              <v-col v-if="social.aparat" cols="auto" xl="auto" lg="auto" md="6" sm="6">
                <a  :href="social.aparat">
                  <v-img class="icon-size" src="@/assets/images/footer/aparat.png"></v-img>
                </a>
              </v-col>
              <v-col v-if="social.whatsapp" cols="auto" xl="auto" lg="auto" md="6" sm="6">
                <a  :href="social.whatsapp">
                  <v-img class="icon-size" src="@/assets/images/footer/whatsapp.png"></v-img>
                </a>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <div class="footer-copyright">
        طراحی و پیاده سازی توسط <a target="_blank" href="https://iracode.com/">شرکت برنامه نویسی ایراکد</a>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import {GET_CONTACT_DETAILS, GET_SOCIAL} from "../../store/homeManagement/action_types";
import {mapState} from "vuex";
import {GET_INFO} from "../../store/infoManagement/action_types";
export default {
  name: "foot",
  created() {
    this.$store.dispatch(`homeManagement/${GET_SOCIAL}`);
    this.$store.dispatch(`homeManagement/${GET_CONTACT_DETAILS}`);
    // this.$store.dispatch(`infoManagement/${GET_INFO}`);
  },
  computed:{
    ...mapState({
      social:state => state.homeManagement.socialMedia,
      info: state => state.infoManagement.info,
      contact:state => state.homeManagement.contactDetails,
      loading:state => state.homeManagement.loading,
    })
  }
}
</script>
<style scoped>
p{
  font-size: 12px;
}
.f-icon{
  cursor: pointer;
  padding: 3px;
  background: #f2c303;
}
.footer-background{
  background: #000000AD;
}
.icon-size{
  height: 24px;
  width: 24px;
  margin: auto;
  object-fit: fill;
}
.icon-size:hover{
  overflow: hidden;
  transform: scale(1.2);
  transition: transform .4s;
}
.legend.sub {
  text-align: center;
  width: 120px;
  padding: 10px 20px;
  margin-left: 40px;
  margin-right: 20px;
  display: inline-block;
}
.legend {
  position: relative;
cursor: pointer;
  width: 205px;
  margin-right: 20px;
  padding: 20px 35px;
  color: #FFF;
  /*background-color: #232426;*/
  background-color: transparent;
  border: 2px solid white;
  border-radius: 3px;
  font-family: Ubuntu,sans-serif;
  font-size: 16px;
  font-weight: 700;
  text-align: right;
  text-transform: uppercase;
  line-height: 1.15em;
}
.legend:after {
  position: absolute;
  right: -18px;
  top: 20px;
  border: 8px solid transparent;
  border-left-color: #FFF;
  border-top-color: #FFF;
  content: "";
}
.f-left-border{
  border-right: 1px solid #ffffff;
}
.f-bottom-border{
  width: 95%;
  margin: auto;
  border-bottom: 1px solid #ffffff;
}
ul {
  list-style: none;
}
li{
  display: flex;
  text-align: right;
  direction: rtl;
  padding-bottom: 30px;
}
.list-decor{
  color: #F2C303;
}

li:hover>i{
  color:#0846be;
  text-decoration: none;
}
li:hover>a{
  color:#0846be !important;
  text-decoration: underline!important;
}
h2,h5,h3,h6{
  color: white;
}
h5{
  font-weight: bold;
}
.footer-copyright{
  color: #fff;
  text-align: center;
  font-size: 12px;
}
.footer-copyright a{
  color: #fff;
}
</style>
